import firestore, { firebase } from '@/firebase'
import _ from 'lodash'

function getInternshipsByUserIds(userIds) {
  return firestore
    .collection('internships')
    .where('userId', 'in', userIds)
    .get()
    .then(snapshot => {
      return _.orderBy(
        snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id })),
        ['startDate', 'endDate'],
        ['desc', 'desc']
      )
    })
    .catch(err => {
      this.$store.dispatch(
        'showErrorSnackbar',
        err.message || 'Something went wrong'
      )
    })
}

export default {
  state: {
    internships: [],
    coordinatorInternships: []
  },
  getters: {
    internships: state => state.internships,
    coordinatorInternships: state => state.coordinatorInternships
  },
  mutations: {
    setInternships(state, internships) {
      state.internships = internships
    },
    setCoordinatorInternships(state, internships) {
      state.coordinatorInternships = internships
    },
    addInternship(state, internship) {
      state.internships.push(internship)
    },
    updateInternship(state, internship) {
      const idx = state.internships.findIndex(s => s.id === internship.id)
      state.internships[idx] = internship
      state.internships = [...state.internships]
    },
    deleteInternships(state, internships) {
      for (const { id } of internships) {
        const idx = state.internships.findIndex(s => s.id === id)
        state.internships.splice(idx, 1)
      }
    }
  },
  actions: {
    addInternship({ commit }, internship) {
      internship.createdAt = firebase.firestore.FieldValue.serverTimestamp()
      internship.updatedAt = firebase.firestore.FieldValue.serverTimestamp()
      return firestore
        .collection('internships')
        .add(internship)
        .then(doc => doc.get())
        .then(internship => {
          return commit('addInternship', {
            id: internship.id,
            ...internship.data()
          })
        })
    },
    setInternships({ commit }, internships) {
      commit('setInternships', internships)
    },
    getInternships({ commit, rootState }) {
      if(rootState && rootState.user) {
        const userId = rootState.user.profile.id
        return getInternshipsByUserIds([userId]).then(internships => {
          commit('setInternships', internships)
        })
      }
    },
    getCoodinatorInternships({ commit }, userId) {
      return getInternshipsByUserIds(userId).then(internships => {
        commit('setCoordinatorInternships', internships)
      })
    },
    deleteInternships({ commit }, internships) {
      const batch = firestore.batch()
      for (const { id } of internships) {
        const docRef = firestore.collection('internships').doc(id)
        batch.delete(docRef)
      }
      return batch.commit().then(() => {
        commit('deleteInternships', internships)
      })
    },
    updateInternship({ commit, rootState }, internship) {
      internship.updatedAt = firebase.firestore.FieldValue.serverTimestamp()
      return firestore
        .collection('internships')
        .doc(internship.id)
        .update(internship)
        .then(() => {
          return commit('updateInternship', internship, rootState.langValue)
        })
    }
  }
}
